<template>
  <page-wrapper title="รายงาน Earn Coin" ref="pageEl">
    <div class="page-container row" ref="page-container">
      <div class="report-filter col-12">
          <div class="form">

            <div class="section">
              <div>
                <div class="label">วันที่ได้รับ MNC</div>
                <date-picker
                  v-model="receiveMNCdateRange"
                  :disabled="!isDropdownDisabled"
                  type="daterange"
                ></date-picker>
              </div>
              <div>
                <div class="label">โครงการ</div>
                <project-select
                  v-model="selectedProject"
                  :disabled="!isDropdownDisabled"
                  v-bind:selectedProjectCode="selectedProject"
                >
                </project-select>
              </div>
            </div>

            <div class="section">
              <div>
                <div class="label">กิจกรรมที่ได้รับ MNC</div>
                <el-select
                  v-model="selectedMncEvent"
                  :disabled="!isDropdownDisabled"
                  style="width: 100%"
                >
                  <el-option
                    v-for="(t, idx) in filterMncEvent"
                    :key="idx"
                    :label="t.label"
                    :value="t.value"
                  ></el-option>
                </el-select>
              </div>
              <div>
                <div class="label">Transaction Status</div>
                <el-select
                  v-model="selectedTransactionStatus"
                  :disabled="!isDropdownDisabled"
                  style="width: 100%"
                >
                  <el-option
                    v-for="(t, idx) in filterTransactionStatus"
                    :key="idx"
                    :label="t.label"
                    :value="t.value"
                  ></el-option>
                </el-select>
              </div>
            </div>

            <div style="
              display: flex;
              justify-content: center;
            ">

              <el-button
                type="primary"
                :disabled="
                  !isSearchDisabled
                "
                @click="
                  handleSearch
                ">
                ค้นหา
              </el-button>
              
              <el-button
                type="info"
                :disabled="
                  !isClickDownloadAsCSVDisabled
                "
                @click.prevent="
                  downloadFileReport
                ">
                ดาวน์โหลด
              </el-button>

              <el-button 
                plain
                type="danger"
                :disabled="
                  !isClearDisabled
                "
                @click="
                  handleClickClear
                ">
                รีเซ็ต
              </el-button>

            </div>

        </div>
      </div>

      <div class="report-content col-12">
        <div>
          <div
            v-show="latestUpdateTime"
            class="report-header"
          >
            <div>
              <b>รายงานอัปเดต</b>
              <p>
                {{ latestUpdateMessage() }}
              </p>
            </div>
            <div>
              <div>
                <p>
                  {{ totalCount }}
                </p>
              </div>
              <div align="right">
                <el-button
                  v-for="
                    i in [10, 20, 30]
                  "
                  :key="i"
                  circle
                  size="small"
                  :type="
                    limit == i ? 'primary' : ''
                  "
                  @click="
                    limit = i
                  ">
                  {{ i }}
                </el-button>
              </div>
            </div> 
          </div>
          
          <div class="mt-3">
            <DataTable
              :data="reports"
              :headers="headers"
              :loading="tableLoading"
            ></DataTable>
          </div>

          <div style="text-align: center;">
            <el-pagination
              background
              layout="
                prev, pager, next
              "
              :total="total"
              :disabled="
                !isPaginationDisable
              "
              :current-page="page"
              :page-size="limit"
              @current-change="
                handleCurrentChange
              ">
            </el-pagination>
          </div>
        </div>

      </div>
    </div>
  </page-wrapper>
</template>

<script>
import { DateTime } from "luxon"
import { baanRueJaiClient } from "@/dependencies"
import { formatOrFallbackToInput } from "@/lib/dateTime"

// Components
import PageWrapper from "@/lib/components/PageWrapper"
import DatePicker from "@/lib/components/DatePicker"
import ScButton from "@/lib/components/ScButton"
import ProjectSelect from "@/lib/components/ProjectSelect"
import DataTable from "@/lib/components/DataTable.vue"
import DropdownUpdateEarnReport from "../component/DropdownUpdateEarnReport"

export default {
  components: {
    PageWrapper,
    DatePicker,
    ScButton,
    ProjectSelect,
    DropdownUpdateEarnReport,
    DataTable
  },
  data() {
    const filterMncEvent = []
    const filterTransactionStatus = [
      { label: "ทั้งหมด", value: undefined },
      { label: "Success", value: "SUCCESS" },
      { label: "Pending", value: "PENDING" },
      { label: "Failed", value: "FAILED" }
    ]
    const receiveMNCdateRange = []

    const headers = [
      {
        label: "ไอดีลูกค้า",
        value: "user_id",
        width: '80px'
      },
      {
        label: "ชื่อกระเป๋า",
        value: "user_wallet_id",
        width: '80px'
      },
      {
        label: "ชื่อลูกค้า",
        value: "user_fullname",
        width: '160px'
      },
      {
        label: 'เบอร์โทรศัพท์',
        value: 'mobile_no',
        width: '100px'
      },
      {
        label: 'อีเมล',
        value: 'email',
        width: '160px'
      },
      {
        label: 'สถานะลูกค้า',
        value: 'customer_status',
        width: '80px'
      },
      {
        label: 'ที่อยู่',
        value: "home_address_no",
        width: '80px'
      },
      {
        label: "รหัสโครงการ",
        value: "project_code"
      },
      {
        label: 'รหัสพนักงาน',
        value: 'employee_id'
      },
      {
        label: "วันที่ได้รับ MNC",
        value: "mnc_received_date",
        width: '100px'
      },
      {
        label: "จำนวนที่ได้รับ MNC (MNC)",
        value: "mnc_received_amount",
        width: '120px'
      },
      {
        label: "จำนวนได้รับ MNC (บาท)",
        value: "mnc_received_value",
        width: '110px'
      },
      {
        label: "Event ที่ได้รับ MNC",
        value: "mnc_event_name",
        width: '180px'
      },
      {
        label: 'ปีของ MNC ที่ได้รับ',
        value: 'mnc_year',
        width: '110px'
      },
      {
        label: "MNC Expired",
        value: "mnc_expired"
      },
      {
        label: "Transaction Status",
        value: "transaction_status"
      },
    ]

    const selectInputFilter = {
      filterMncEvent,
      filterTransactionStatus,
      receiveMNCdateRange,
      selectedProject: undefined,
      selectedMncEvent: undefined,
      selectedTransactionStatus: undefined,
    }

    const isDisabledInput = {
      isDropdownDisabled: true,
      isSearchDisabled: true,
      isClickDownloadAsCSVDisabled: true,
      isClearDisabled: true,
      isPaginationDisable: true,
    }

    const pagination = {
      page: 1,
      limit: 10,
      total: 0,
      latestUpdateTime: "",
    }

    return {
      ...isDisabledInput,
      ...selectInputFilter,
      ...pagination,
      tableLoading: false,
      reports: [],
      headers,
      reportType: 'earn'
    }
  },
  created() {
    this.setupData()
    this.getMNCEventFilterList()
  },
  watch: {
    async "$route.query"() {
      await this.setupData()
      this.$refs.pageEl.$el.querySelector(".page-content").scrollTop = 0
    },
    async limit (from, to) {
      if (from != to) {
        await this.handleSearch()
      }
    }
  },
  computed: {
    totalCount() {
      if (!this.total || this.total === 0) {
        return "ไม่พบข้อมูล"
      }
      const limit = this.limit
      const total = this.total.toLocaleString()
      const currentTotalItem = this.reports.length

      const isLastPage = limit > currentTotalItem
      const currentPage = +this.page || 1
      const end = (isLastPage ? total : currentPage * limit).toLocaleString()
      const start = (
        (isLastPage ? limit * currentPage - limit : end - limit) + 1
      ).toLocaleString()
      return `แสดงผล ${start} - ${end} จากทั้งหมด ${total}`
    },
    queryParams() {
      const {
        selectedProject,
        selectedMncEvent,
        selectedTransactionStatus,
        receiveMNCdateRange,
        page,
        limit
      } = this.$route.query
      return {
        mnc_event: selectedMncEvent,
        transaction_status: selectedTransactionStatus,
        mnc_received_date: this.convertDateRange(receiveMNCdateRange),
        project_code: selectedProject,
        page: (page && +page) || 1,
        limit: +limit || this.limit
      }
    }
  },
  methods: {
    setupData() {
      this.queryBuilder()
      this.fetchReports()
    },
    queryBuilder() {
      const {
        projectId,
        selectedProject,
        selectedMncEvent,
        selectedTransactionStatus,
        receiveMNCdateRange,
        page,
        limit
      } = this.$route.query
      this.projectId = projectId || null
      this.selectedProject = selectedProject || null
      this.selectedMncEvent = selectedMncEvent || null
      this.selectedTransactionStatus = selectedTransactionStatus || null
      this.receiveMNCdateRange = this.setupQueryDateRange(receiveMNCdateRange)
      this.page = (page && +page) || 1
      this.limit = +limit || this.limit
    },
    handleSearch() {
      this.selectedProject = this.selectedProject
        ? this.selectedProject.projectCode
        : null
      const {
        selectedMncEvent,
        selectedTransactionStatus,
        selectedProject,
        receiveMNCdateRange,
        limit
      } = this
      let query = {
        selectedProject,
        selectedMncEvent,
        selectedTransactionStatus,
        receiveMNCdateRange: this.convertDateRange(receiveMNCdateRange),
        limit,
        page: 1
      }
      // NOTE: filter out null value
      query = Object.fromEntries(
        Object.entries(query).filter(([key, value]) => value !== null)
      )
      // NOTE: replace route with query string
      const route = {
        name: this.$route.name,
        query: query
      }
      this.$router.replace(route)
    },
    setupQueryDateRange(dateRange) {
      if (dateRange && dateRange.length > 1) {
        const [from, to] = dateRange
        return [DateTime.fromISO(from), DateTime.fromISO(to)]
      } else {
        return []
      }
    },
    convertDateRange(dateRange) {
      if (dateRange && dateRange.length > 1) {
        return dateRange.map(date => DateTime.fromISO(date).toISO())
      }
    },
    handleClickClear() {
      const route = {
        name: this.$route.name
      }
      this.$router.replace(route)
    },
    handleCurrentChange(page) {
      const route = {
        name: this.$route.name,
        query: { ...this.$route.query, page: (page && +page) || 1 }
      }
      this.$router.replace(route)
    },
    async fetchReports() {
      this.tableLoading = true

      // Initial Default
      let latestUpdate = DateTime.utc()
      let reports = []
      let total = 0

      const query = this.queryParams
      const response = await baanRueJaiClient.admin.tokenx
        .getMNCReport(query, this.reportType)

      // Validate Response
      if(response) {
        const result = response.data.result

        reports = result.reports
        total = result.total
        latestUpdate = result.timestamp
      }

      this.isAbleButton()
      this.tableLoading = false

      // Set Report
      this.reports = reports
      this.total = total
      this.latestUpdateTime = latestUpdate
    },
    async downloadFileReport(event) {

      // get date format 2023-11-06-161249
      const dateFilename = DateTime.utc()
        .setZone('Asia/Bangkok')
        .toFormat('yyyy-MM-dd-HHmmss')

      // Init file name for download report
      const fileName = `${dateFilename}-mnc-${this.reportType}-reports.xlsx`
      event.preventDefault()
      this.isDisableButton()
      
      // Init request params
      const query = this.queryParams
      delete query.page

      // Send request
      const response = await baanRueJaiClient.admin.tokenx
        .downloadEarnMNCReport(query, this.reportType)

      // check response before download
      if (response.data) {
        const blob = new Blob([response.data])
        const link = document.createElement("a")
        link.href = window.URL.createObjectURL(blob)
        link.download = fileName
        link.click()
        link.remove()
      }
      this.isAbleButton()
    },
    isDisableButton() {
      this.isSearchDisabled = false
      this.isClearDisabled = false
      this.isClickDownloadAsCSVDisabled = false
      this.isPaginationDisable = false
      this.isDropdownDisabled = false
    },
    isAbleButton() {
      this.isSearchDisabled = true
      this.isClearDisabled = true
      this.isClickDownloadAsCSVDisabled = true
      this.isPaginationDisable = true
      this.isDropdownDisabled = true
    },
    formatDateToTH(date, format) {
      return formatOrFallbackToInput(date, format)
    },
    latestUpdateMessage() {
      const format = "dd MMMM yyyy เวลา HH:mm น."
      return this.formatDateToTH(this.latestUpdateTime, format)
    },
    async getMNCEventFilterList() {
      // Default Company Code
      let initialList = [
        { label: "ทั้งหมด", value: undefined },
        { label: 'รับ coin จำนวน 1% จากราคาบ้าน', value: 'NEW_HOME_COIN_ONE_PERCENT' },
        { label: "เปิดกระเป๋า wallet", value: "CUSTOMER_CREATE_WALLET" },
        { label: "ซื้อของ RJ 1%", value: "BUY_RJ_PACKAGE_ONE_PERCENT" }
      ]

      // Get unique data
      const data = await this.fetchUniqueData('mnc_event')

      const mappingList = data.map(item => ({
        label: item.mnc_event_name,
        value: item.mnc_event
      }))

      // Set State
      this.filterMncEvent = initialList.concat(mappingList)
    },
    async fetchUniqueData(fieldName) {
      let result = []
      try {
        // Fetch Company Code
        const {
          data
        } = await baanRueJaiClient.admin.tokenx.getUniqueDataFromReport(fieldName)

        // Validate Fetch Result
        if (!data || !data.result) throw new Error("Data Not Found")

        // Set result
        result = data.result
      } catch ({ message, stack }) {
        console.warn(`fetch-${fieldName}`, message, stack)
      }
      return result
    },
  }
}
</script>

<style lang="scss" scoped>
@import "~@/lib/scss/variables";
.header {
  z-index: 1;
}

.page-container {
  padding: 15px;
}

.report-cell {
  a {
    text-decoration: underline;
  }

  padding: 5px;
  border-left: 1px solid rgb(206, 204, 204);
  border-bottom: 1px solid rgb(228, 225, 225);

  &:empty::before {
    content: "N/A";
    color: #d8d8d8;
  }
}

.page-container {
  padding: 1rem;
  margin: 0;
}

.report-filter {
  width: 100%;
  display: flex;
  gap: 1rem;
  justify-content: center;
}

.report-filter .form {
  display: flex;
  flex-direction: column;
  gap: 1rem;
}

.form .section {
  display: grid;
  gap: 1rem;
  margin-top: 15px;
  grid-template-columns: repeat(2, 1fr);
}

.form .section[col="3"] {
  grid-template-columns: repeat(3, 1fr);
}

.label {
  font-size: .9rem;
  margin-bottom: .25rem;
}

.report-content {
  display: flex;
  flex-direction: column;
  gap: 1rem; 
}

.report-content .report-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.el-button.el-button--danger.is-plain:hover,
.el-button.el-button--danger.is-plain:focus {
  color: white !important;
}

@media screen and (max-width: 640px) {
  .form .section, 
  .form .section[col="3"] {
    grid-template-columns: 1fr;
  }

  .report-filter {
    margin-bottom: 1rem;
  }
}

.el-input__inner {
  text-align: center;
}

.el-date-editor--daterange,
.el-input__inner {
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/features/morning-coin/pages/EarnCoinReportPage.vue